<div class="details">
  <div class="info-line">
    <mat-icon>calendar_month</mat-icon>
    <div class="body-text-bold">{{ slot.from | customDate:'cccc, dd.MM.yyyy' }}</div>
  </div>
  <div class="info-line">
    <mat-icon>schedule</mat-icon>
    <div class="body-text">{{ slot.from | customDate:'HH:mm' }} · {{ 'waitlist.slot.minutes' | transloco: {minutes: durationMinutes} }}</div>
  </div>
  @if (slot.employeeName) {
    <div class="info-line">
      <mat-icon>person</mat-icon>
      <div class="body-text">{{ slot.employeeName }}</div>
    </div>
  }
</div>
